__webpack_require__.p = "https://static.vigolive.cn/homepage/";